const CXENSE_API_URL = {
  local: '//cxense.local/api',
  development: '//www.dev.nm.cbc.ca/cxense/v1/search',
  qa: '//www.qa.nm.cbc.ca/cxense/v1/search',
  production: '//www.cbc.ca/cxense/v1/search'
};

export { CXENSE_API_URL };



// WEBPACK FOOTER //
// ./src/config.js